export default __webpack_public_path__ + "static/media/LOGO_ALT.34d9fcdd.svg";